import { Badge, TypeBadgeProps } from '@thefarmersfront/kitchen-mobile';

import styles from './RecruitBadge.module.scss';

export const RecruitBadge = ({ value, ...props }: TypeBadgeProps) => {
  return (
    <Badge
      value={value}
      color="secondary"
      variant="light"
      shape="square"
      size="small"
      className={styles.badge}
      {...props}
    />
  );
};
